import { BasicType } from "@easy-email-pro-core/constants";
import { DangerousCodeElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type CodeProps = RecursivePartial<DangerousCodeElement["attributes"]> & {
  idx?: string | null;
  children:string;
};

export function Code(props: CodeProps) {
  const { children, idx, ...rest } = props;
  const node: DangerousCodeElement = {
    type: BasicType.DANGEROUS_CODE,
    data: { code:String(children) },
    attributes: { ...rest } as any,
    children:[]
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={null}
    />
  );
}
